export default {
  state: { //状态器
    //hide状态解释      	10子菜单隐藏主选项显示	  11子菜单主菜单都显示    12子菜单主菜单都隐藏
    //  对应第三集路由才能锁定高亮 如个人档案
    items: [
      // {
      // 	name: "加入或创建企业",
      // 	id: "A0000",
      // 	icon: "iconfont iconloufang101",
      // 	router: "/projectsubject/jurisdiction/skipPage",
      // 	hide: "10",
      // 	child: []
      // },
      //				{
      //					name:"新闻咨询",
      //					id:"B0000",
      //					icon:"iconfont iconxiaoxi",
      //					router:"/projectsubject/newsConsulting",
      //					hide:"10",
      //					child:[]
      //				},
      // {
      // 	name: "首页",
      // 	id: "C0000",
      // 	icon: "iconfont iconloufang101",
      // 	router: "/projectsubject/administrative/projectDistribution",
      // 	hide: "10",
      // 	child: [
      // 		{
      // 			name: "项目分布",
      // 			icon: "iconfont iconkehufenbutu",
      // 			id: "C01000",
      // 			router: "/projectsubject/administrative/projectDistribution",
      // 			hide: "10",
      // 			child: []
      // 		}, {
      // 			name: "投资进度",
      // 			icon: "iconfont iconjindu",
      // 			id: "C02000",
      // 			router: "/projectsubject/administrative/InvestmentProgress",
      // 			hide: "10",
      // 			child: []

      // 		}, {
      // 			name: "质量安全",
      // 			icon: "iconfont iconiconfontanquan",
      // 			id: "C03000",
      // 			router: "/projectsubject/administrative/QSMark",
      // 			hide: "10",
      // 			child: []

      // 		},
      // 	]
      // },
      // {
      //   name: "园区管理",
      //   icon: "iconfont iconqiyeguanli",
      //   router: "/projectsubject/project",
      //   hide: "11",
      //   id: "D0000",
      //   routerName: 'project',
      //   child: [{
      //       name: "项目进度",
      //       id: "company.project.progress",
      //       routerName: 'schedule',
      //       router: "/projectsubject/project/schedule",
      //       hide: "10",
      //       child: []
      //     },{
      //       name: "督办管理",
      //       id: "company.project.progress",
      //       routerName: 'supervisionManage',
      //       router: "/projectsubject/project/supervisionManage",
      //       hide: "10",
      //       child: []
      //     }]
      // },
      {
        name: "园区管理",
        icon: "iconfont iconqiyeguanli",
        router: "/projectsubject/businessAdministration",
        hide: "11",
        id: "D0000",
        routerName: 'businessAdministration',
        child: [
          // {
          //   name: "企业名片",
          //   //									icon:"iconfont iconmingpian",
          //   id: "D0100",
          //   routerName: 'busCard',
          //   router: "/projectsubject/businessAdministration/busCard",
          //   hide: "10",
          //   child: []
          // },
          {
            name: "项目进度",
            id: "company.project.progress",
            routerName: 'schedule',
            router: "/projectsubject/project/schedule",
            hide: "10",
            child: []
          },
          {
            name: "督办管理",
            //									icon:"iconfont iconmingpian",
            // id: "company.order.supervisor",
            id: "D0000",
            routerName: 'workOrder',
            router: "/projectsubject/businessAdministration/workOrder",
            hide: "10",
            child: []
          },
          {
            name: "问题汇总",
            //									icon:"iconfont iconmingpian",
            // id: "company.order.supervisor",
            id: "D0000",
            routerName: 'problemSummary',
            router: "/projectsubject/problemSummary",
            hide: "10",
            child: []
          },
          // {
          //   name: "BIM",
          //   //									icon:"iconfont iconmingpian",
          //   id: "D0100",
          //   routerName: 'bimTamplate',
          //   router: "/projectsubject/businessAdministration/bimTamplate",
          //   hide: "10",
          //   child: []
          // },
          {
            name: "项目统计",
            //									icon:"iconfont iconmingpian",
            id: "company.project.statistic",
            routerName: 'intelligenceReports',
            router: "/projectsubject/businessAdministration/intelligenceReports",
            hide: "10",
            child: []
          },
          {
            name: "园区人员",
            //									icon:"iconfont iconrenyuanliebiao",
            id: "company.user",
            routerName: 'enterprisePersonnel',
            router: "/projectsubject/businessAdministration/enterprisePersonnel",
            hide: "10",
            child: []
          },
          {
            name: "入园申请",
            //									icon:"iconfont iconjiarujiazu",
            id: "company.user.apply",
            routerName: 'applyfor',
            router: "/projectsubject/businessAdministration/applyfor",
            hide: "10",
            child: []
          },
          // {
          //   name: "证书管理",
          //   //									icon:"iconfont iconzhengshu-copy",
          //   id: "company.book",
          //   routerName: 'cerManageTable',
          //   router: "/projectsubject/businessAdministration/cerManage/cerManageTable",
          //   hide: "10",
          //   child: []
          // },
          // {
          //   name: "财务管理",
          //   //									icon:"iconfont iconchakanxiangqing",
          //   id: "company.finance",
          //   routerName: 'financialManagement',
          //   router: "/projectsubject/businessAdministration/financialManagement",
          //   hide: "10",
          //   child: [{
          //       name: "工程款拨付",
          //       //											icon:"iconfont icontubiao-",
          //       id: "company.finance.payment",
          //       routerName: 'projectFunds',
          //       router: "/projectsubject/businessAdministration/financialManagement/projectFunds",
          //       hide: "10",
          //       child: [{
          //         name: "项目记录",
          //         id: "company.finance.payment",
          //         routerName: 'collectionData',
          //         router: "/projectsubject/businessAdministration/financialManagement/projectFunds/collectionData",
          //         hide: "10",
          //         child: [{
          //             name: "项目记录",
          //             id: "D060A",
          //             routerName: 'collectionData',
          //             router: "/projectsubject/businessAdministration/financialManagement/projectFunds/collectionData",
          //             hide: "10",
          //             child: []
          //           },
          //           {
          //             name: "拨付款记录",
          //             id: "D060A",
          //             routerName: 'collectionData',
          //             router: "/projectsubject/businessAdministration/financialManagement/projectFunds/collectionData/collectionPersonnelDetails",
          //             hide: "10",
          //             child: []
          //           }
          //         ]
          //       }]
          //     },
          //     {
          //       name: "保证金管理",
          //       //											icon:"iconfont  iconbaozhengjin",
          //       id: "company.finance.deposit",
          //       routerName: 'marginMoney',
          //       router: "/projectsubject/businessAdministration/financialManagement/marginMoney",
          //       hide: "10",
          //       child: []
          //     }
          //   ]
          // },
          // {
          //   name: "电子签章",
          //   //				      				icon:"iconfont iconpdf_icon_CompanySeal",
          //   id: "company.sign",
          //   routerName: 'sealList',
          //   router: "/projectsubject/businessAdministration/sealList",
          //   hide: "10",
          //   child: [{
          //       name: "印章管理",
          //       //											icon:"iconfont icontubiao-",
          //       id: "D060A",
          //       routerName: 'sealManage',
          //       router: "/projectsubject/businessAdministration/sealList/sealManage",
          //       hide: "10",
          //       child: []
          //     },
          //     {
          //       name: "盖章申请",
          //       //											icon:"iconfont  iconhuanyuan-",
          //       id: "D060B",
          //       routerName: 'sealApplyFor',
          //       router: "/projectsubject/businessAdministration/sealApplyFor",
          //       hide: "10",
          //       child: []
          //     }
          //   ]
          // },
          // {
          //   name: "出差管理",
          //   // icon:"iconfont iconbaozhengjin",
          //   id: "company.business.trip",
          //   router: "/projectsubject/businessAdministration/onBusiness",
          //   child: [{
          //       name: "出差统计",
          //       // icon:"iconfont iconhuanyuan-",
          //       id: "company.business.trip.statistic",
          //       router: '/projectsubject/businessAdministration/onBusiness/onBusinessStatistics',
          //       hide: "10",
          //       child: []
          //     },
          //     {
          //       name: "出差记录",
          //       // icon:"iconfont iconhuanyuan-",
          //       id: "D080B",
          //       router: '/projectsubject/businessAdministration/onBusiness/onBusinessRecord',
          //       hide: "10",
          //       child: []
          //     },
          //   ]
          // },
          // {
          //   name: '企业合同管理',
          //   id: 'D080E',
          //   router: '/projectsubject/businessAdministration/comparyContract',
          //   child: [{
          //       name: '所有项目合同',
          //       id: 'D080E1',
          //       router: '/projectsubject/businessAdministration/comparyContract/allComparyContract',
          //       hide: '10',
          //       child: []
          //     },
          //     {
          //       name: '企业级合同',
          //       id: 'D080E2',
          //       router: '/projectsubject/businessAdministration/comparyContract/comparyContract',
          //       hide: '10',
          //       child: []
          //     }
          //   ]
          // },
          // {
          //   name: "商务报价",
          //   //									icon:"iconfont iconrenyuanliebiao",
          //   id: "company.business.offer",
          //   routerName: 'commercialQuotation',
          //   router: "/projectsubject/businessAdministration/commercialQuotation/commercialQuotationTable",
          //   hide: "10",
          //   child: []
          // },
          // {
          //   name: "项目阶段",
          //   //									icon:"iconfont iconrenyuanliebiao",
          //   id: "D080C",
          //   routerName: 'enterPriseProjectStage',
          //   router: "/projectsubject/businessAdministration/enterPriseProject/enterPriseProjectStage",
          //   hide: "10",
          //   child: []
          // },
          // {
          //   name: "企业公告",
          //   //									icon:"iconfont iconrenyuanliebiao",
          //   id: "D080D",
          //   routerName: 'companyNoticeList',
          //   router: "/projectsubject/businessAdministration/companyNoticeList",
          //   hide: "10",
          //   child: []
          // },

          // {
          // name:"保证金申请",
          //									icon:"iconfont iconbaozhengjin",
          // id:"D0700",
          // router:"/projectsubject/businessAdministration/marginMoney",
          // hide:"10",
          // child:[
          // 	{
          // 		name:"缴纳申请审批中",
          // 		icon:"iconfont iconhuanyuan-",
          // 		id:"D070A",
          // 		router:'/projectsubject/businessAdministration/marginMoney/marginMoneyList',
          // 		hide:"10",
          // 		child:[]
          // 	},
          // ]
          // },
        ]
      },
      // {
      //   name: "人事管理",
      //   icon: "iconfont iconrenshiguanli",
      //   router: "/projectsubject/personnelManagement",
      //   hide: "11",
      //   id: "G0000",
      //   routerName: 'personnelManagement',
      //   child: [{
      //       name: "假勤管理",
      //       router: "/projectsubject/personnelManagement/leaveModule/leaveView",
      //       hide: "11",
      //       id: "attendanceH0000",
      //       routerName: 'leaveView',
      //       child: [{
      //           name: "请假",
      //           id: "attendanceI0000",
      //           routerName: 'leaveList',
      //           router: "/projectsubject/personnelManagement/leaveModule/leaveList",
      //           hide: "10",
      //           child: [],
      //         },
      //         {
      //           name: "外勤",
      //           id: "attendanceI0001",
      //           routerName: 'fieldList',
      //           router: "/projectsubject/personnelManagement/leaveModule/fieldList",
      //           hide: "10",
      //           child: [],
      //         },
      //         {
      //           name: "加班",
      //           id: "attendanceI0002",
      //           routerName: 'overtimeList',
      //           router: "/projectsubject/personnelManagement/leaveModule/overtimeList",
      //           hide: "10",
      //           child: [],
      //         },
      //         {
      //           name: "补卡",
      //           id: "attendanceI0003",
      //           routerName: 'makeUpCardList',
      //           router: "/projectsubject/personnelManagement/leaveModule/makeUpCardList",
      //           hide: "10",
      //           child: [],
      //         },
      //         // {
      //         //   name: "出差",
      //         //   id: "I0004",
      //         //   routerName: 'leaveList',
      //         //   router: "/d",
      //         //   hide: "10",
      //         //   child: [],
      //         // },
      //         {
      //           name: "出差记录",
      //           // icon:"iconfont iconhuanyuan-",
      //           id: "company.business.trip",
      //           router: '/projectsubject/businessAdministration/onBusiness/onBusinessRecord',
      //           hide: "10",
      //           child: []
      //         },
      //         {
      //           name: "出差统计",
      //           // icon:"iconfont iconhuanyuan-",
      //           id: "company.business.trip.statistic",
      //           router: '/projectsubject/businessAdministration/onBusiness/onBusinessStatistics',
      //           hide: "10",
      //           child: [],
      //         },
      //         {
      //           name: "考勤设置",
      //           id: "company.setAttendance",
      //           routerName: 'attendanceList',
      //           router: "/projectsubject/personnelManagement/leaveModule/attendanceList",
      //           hide: "10",
      //           child: [],
      //         },
      //         {
      //           name: "考勤统计",
      //           id: "company.attendanceList",
      //           routerName: 'attendanceStatistics',
      //           router: "/projectsubject/personnelManagement/leaveModule/attendanceStatistics",
      //           hide: "10",
      //           child: [],
      //         },
      //       ]
      //     },
      // {
      //   name: "人事档案",
      //   router: "/projectsubject/personnelManagement/archivesModule/archivesView",
      //   hide: "11",
      //   id: "company.personalRecord",
      //   routerName: 'archivesView',
      //   child: [{
      //       name: "员工档案",
      //       id: "attendanceI0007",
      //       routerName: 'employeeFile',
      //       router: "/projectsubject/personnelManagement/archivesModule/employeeFile",
      //       hide: "10",
      //       child: [],
      //     },
      //     {
      //       name: "入职管理",
      //       id: "attendanceI0008",
      //       routerName: 'induction',
      //       router: "/projectsubject/personnelManagement/archivesModule/induction",
      //       hide: "10",
      //       child: [],
      //     },
      //     {
      //       name: "转正记录",
      //       id: "attendanceI0009",
      //       routerName: 'onTrial',
      //       router: "/projectsubject/personnelManagement/archivesModule/onTrial",
      //       hide: "10",
      //       child: [],
      //     },
      //     {
      //       name: "离职记录",
      //       id: "attendanceI0010",
      //       routerName: 'quit',
      //       router: "/projectsubject/personnelManagement/archivesModule/quit",
      //       hide: "10",
      //       child: [],
      //     },
      //   ]
      // },
      // {
      //   name: "个人档案",
      //   router: "/projectsubject/personnelManagement/personalArchivesModule/personalArchives",
      //   hide: "11",
      //   id: "attendanceH0002",
      //   routerName: 'personalArchives',
      //   child: []
      // }
      // ]

      // },
      // {
      //   name: "项目管理",
      //   icon: "iconfont iconicon-project",
      //   id: "company.project",
      //   routerName: 'projectManagement',
      //   router: "/projectsubject/projectManagement",
      //   hide: "10",
      //   child: [
      {
        name: "项目管理",
        icon: "iconfont iconicon-project",
        id: "projectE0100",
        routerName: 'projectList',
        router: "/projectsubject/projectManagement/listMessage/projectList",
        hide: "12",
        child: [{
            name: "项目信息",
            //											icon:"iconfont icongongchengxiangmuxinxi",
            id: "project.base.operation",
            routerName: 'itemInformation',
            router: "/projectsubject/projectManagement/listMessage/itemInformation",
            hide: "10",
            child: []
          },
          {
            name: "项目进度",
            id: "project.progress.control",
            routerName: 'projectPlan',
            router: "/projectsubject/projectManagement/listMessage/projectPlan",
            hide: "10",
            child: []
          },
          {
            name: "工单督办",
            id: "projectWorkOrderE0113",
            routerName: 'projectWorkOrder',
            router: "/projectsubject/projectManagement/listMessage/projectWorkOrder",
            hide: "10",
            child: []
          },
          // {
          //   name: "物资管理",
          //   id: "project.material",
          //   routerName: 'materialsManagement',
          //   router: "/projectsubject/projectManagement/listMessage/materialsManagement",
          //   hide: "10",
          //   child: []
          // },
          {
            name: "数据报表",
            //											icon:"iconfont icongongchengxiangmuxinxi",
            id: "project.statistic",
            routerName: 'dataReport',
            router: "/projectsubject/projectManagement/listMessage/dataReport",
            hide: "10",
            child: []
          },
          // {
          //   name: "项目文件",
          //   //											icon:"iconfont iconicon_project",
          //   id: "project.file",
          //   routerName: 'itemFile',
          //   router: "/projectsubject/projectManagement/listMessage/itemFile",
          //   hide: "10",
          //   child: []
          // },
          {
            name: "人员管理",
            //											icon:"iconfont iconrenyuanguanli",
            id: "project.user",
            routerName: 'peopleManage',
            router: "/projectsubject/projectManagement/listMessage/peopleManage",
            hide: "10",
            child: []
          },
          // {
          //   name: "资金管理",
          //   //											icon:"iconfont iconzijinchijiaoyichaxun",
          //   id: "project.finance",
          //   routerName: 'fundsManagement',
          //   router: "/projectsubject/projectManagement/listMessage/fundsManagement",
          //   hide: "10",
          //   child: [{
          //     name: "资金拨付申请",
          //     id: "project.finance",
          //     routerName: 'allocatedDetail',
          //     router: "/projectsubject/projectManagement/listMessage/fundsManagement/allocatedDetail",
          //     hide: "10",
          //     child: []
          //   }]
          // },
          // {
          //   name: '合同管理',
          //   id: 'E0200',
          //   router: '/promanage/projectlist/projectContract/projectContractTable',
          //   hide: '10',
          //   child: []
          // },
          // {
          //   name: "质量检查",
          //   //											icon:"iconfont iconzhilianganquan",
          //   id: "project.quality",
          //   routerName: 'qualityInspection',
          //   router: "/projectsubject/projectManagement/listMessage/qualityInspection",
          //   hide: "10",
          //   child: []
          // },

          // { // 安全检查 ，第一个版本
          //   name: "安全检查",
          //   //											icon:"iconfont iconanquanmao",
          //   id: "project.security",
          //   routerName: 'securityCheck',
          //   router: "/projectsubject/projectManagement/listMessage/securityCheck",
          //   hide: "10",
          //   child: []
          // },

          // { // 安全质量检查 ，第二个版本 安全质量检查2
          //   name: "安全检查",
          //   id: "project.security",
          //   routerName: 'SafetyQualityInspection',
          //   router: "/projectsubject/projectManagement/listMessage/SafetyQualityInspection",
          //   hide: "10",
          //   child: []
          // },

          // {
          //   name: "项目阶段",
          //   //											icon:"iconfont iconanquanmao",
          //   id: "E0111",
          //   routerName: 'projectPhaseList',
          //   router: "/projectsubject/projectManagement/listMessage/projectPhaseList",
          //   hide: "10",
          //   child: []
          // },
          // 										{
          // 											name:"视频监控",
          // //											icon:"iconfont iconanquanmao",
          // 											id:"E01011E",
          // 											router:"/projectsubject/projectManagement/listMessage/videoSurveillance",
          // 											hide:"10",
          // 											child:[]
          // 										},
          // {
          //   name: "项目公告",
          //   //									icon:"iconfont iconrenyuanliebiao",
          //   id: "E0112",
          //   routerName: 'projectNoticeList',
          //   router: "/projectsubject/projectManagement/listMessage/projectNoticeList",
          //   hide: "10",
          //   child: []
          // },
          // {
          //   name: "疫情防控",
          //   //											icon:"iconfont iconanquanmao",
          //   id: "E01011F",
          //   routerName: 'videoSurveillance',
          //   router: "/projectsubject/projectManagement/listMessage/videoSurveillance",
          //   hide: "10",
          //   child: []
          // }
        ]
      },
      //								{
      //									name:"归档备案",
      //									icon:"iconfont iconbaocun",
      //									id:"company.archive",
      //									router:"/projectsubject/projectManagement/archive",
      //									hide:"10",
      //									child:[]
      //								},
      // {
      // 	name: "项目日志",
      // 	//									icon:"iconfont iconrizhiguanli",
      // 	id: "E0400",
      // 	router: "/projectsubject/projectManagement/projectLog",
      // 	hide: "10",
      // 	child: []
      // },
      // {
      //   name: "施工日志",
      //   //									icon:"iconfont iconrizhiguanli",
      //   id: "company.construction.log",
      //   routerName: 'siteBuildingLog',
      //   router: "/projectsubject/projectManagement/siteBuildingLog",
      //   hide: "10",
      //   child: []
      // },
      // {
      //   name: "监理日志",
      //   //									icon:"iconfont iconrizhiguanli",
      //   id: "company.supervision.log",
      //   routerName: 'supervisorLog',
      //   router: "/projectsubject/projectManagement/supervisorLog",
      //   hide: "10",
      //   child: []
      // },
      // {
      //   name: "项目进度",
      //   //									icon:"iconfont iconrizhiguanli",
      //   id: "project.progress.control",
      //   routerName: 'projectSchedule',
      //   router: "/projectsubject/projectManagement/projectSchedule",
      //   hide: "10",
      //   child: []
      // },
      // {
      //   name: "回收站",
      //   //									icon:"iconfont iconhuishouzhan",
      //   id: "company.recycle",
      //   routerName: 'recycleBin',
      //   router: "/projectsubject/projectManagement/recycleBin",
      //   hide: "10",
      //   child: []
      // }
      //   ]
      // },
      // {
      //   name: "我的审批",
      //   icon: "iconfont iconrizhiguanli",
      //   id: "F0000",
      //   routerName: 'myApproval',
      //   router: '/projectsubject/projectManagement/myApproval',
      //   hide: "10",
      //   child: [{
      //       name: "文件审批",
      //       //		        			icon:"iconfont icontiezixiugai",
      //       id: "F0100",
      //       routerName: 'fileApproval',
      //       router: '/projectsubject/projectManagement/myApproval/fileApproval',
      //       hide: "10",
      //       child: []
      //     },
      //     {
      //       name: "人事审批",
      //       //		        			icon:"iconfont icontiezixiugai",
      //       id: "F0800",
      //       routerName: 'humanResourcesView',
      //       router: '/projectsubject/projectManagement/myApproval/humanResourcesView',
      //       hide: "10",
      //       child: [{
      //           name: "假勤审批",
      //           id: "F0900",
      //           routerName: 'vacationAttendanceApprove',
      //           router: '/projectsubject/projectManagement/myApproval/vacationAttendanceApprove',
      //           hide: "10",
      //           child: []
      //         },
      //         {
      //           name: "人事档案审批",
      //           id: "F1000",
      //           routerName: 'archivesApprove',
      //           router: '/projectsubject/projectManagement/myApproval/archivesApprove',
      //           hide: "10",
      //           child: []
      //         },
      //       ]
      //     },
      //     {
      //       name: "资金审批",
      //       //		        			icon:"iconfont iconfapiaoshenhe",
      //       id: "F0200",
      //       routerName: 'fundApproval',
      //       router: '/projectsubject/projectManagement/myApproval/fundApproval',
      //       hide: "10",
      //       child: [{
      //           name: "待我审批",
      //           id: "F0200",
      //           routerName: 'pendingApprove',
      //           router: '/projectsubject/projectManagement/myApproval/fundApproval/pendingApprove',
      //           hide: "10",
      //           child: []
      //         },
      //         {
      //           name: "我已审批",
      //           id: "F0200",
      //           routerName: 'alreadyApprove',
      //           router: '/projectsubject/projectManagement/myApproval/fundApproval/alreadyApprove',
      //           hide: "10",
      //           child: []
      //         },
      //         {
      //           name: "我发起的",
      //           id: "F0200",
      //           routerName: 'initiateApprove',
      //           router: '/projectsubject/projectManagement/myApproval/fundApproval/initiateApprove',
      //           hide: "10",
      //           child: []
      //         },
      //         {
      //           name: "分类统计",
      //           id: "F0200",
      //           routerName: 'sortStatistic',
      //           router: '/projectsubject/projectManagement/myApproval/fundApproval/sortStatistic',
      //           hide: "10",
      //           child: []
      //         },
      //       ]
      //     },
      //     {
      //       name: "保证金审批",
      //       //		        			icon:"iconfont iconfapiaoshenhe",
      //       id: "F0300",
      //       routerName: 'marginMoneyApplyFor',
      //       router: '/projectsubject/projectManagement/myApproval/marginMoney',
      //       hide: "10",
      //       child: []
      //     },
      //     {
      //       name: "证书借用审批",
      //       //		        			icon:"iconfont iconfapiaoshenhe",
      //       id: "F0400",
      //       routerName: 'credential',
      //       router: '/projectsubject/projectManagement/myApproval/credential',
      //       hide: "10",
      //       child: []
      //     },
      //     {
      //       name: "出差审批",
      //       // icon:"iconfont iconhuanyuan-",
      //       id: "F0500",
      //       router: '/projectsubject/businessAdministration/onBusiness/onBusinessApprove',
      //       hide: "10",
      //       child: []
      //     },
      //     {
      //       name: "发料审批",
      //       //		        			icon:"iconfont icontiezixiugai",
      //       id: "F0600",
      //       routerName: 'materialsApproval',
      //       router: '/projectsubject/projectManagement/myApproval/materialsApproval',
      //       hide: "10",
      //       child: []
      //     },

      //     {
      //       name: "安全检查整改/复查",
      //       //		 icon:"iconfont icontiezixiugai",
      //       id: "F0700",
      //       routerName: 'myApprovalSecurity',
      //       router: '/projectsubject/projectManagement/myApproval/security',
      //       hide: "10",
      //       child: []
      //     },
      //   ]
      // },
      //				{
      //					name:"信息查询",
      //					icon:"iconfont iconfangdajing",
      //					id:"G0000",
      //					router:"",
      //					hide:"00",
      //					child:[]
      //				},
      {
        name: "系统设置",
        icon: "iconfont iconxitongshezhi",
        id: "company.system",
        routerName: 'processTipsView',
        router: "/projectsubject/systemSettings/processTipsView",
        hide: "11",
        child: [
          // {
          //   name: "流程提示设置",
          //   //		 icon:"iconfont icontiezixiugai",
          //   id: "company.system.process.tips",
          //   routerName: 'processTips',
          //   router: '/projectsubject/systemSettings/processTips',
          //   hide: "10",
          //   child: []
          // },
          {
            name: "告警设置",
            //		 icon:"iconfont icontiezixiugai",
            id: "company.system.alarm",
            routerName: 'workAlarm',
            router: '/projectsubject/systemSettings/workAlarm',
            hide: "10",
            child: []
          },
          {
            name: "工单时间管理设置",
            //		 icon:"iconfont icontiezixiugai",
            id: "company.system.time.management",
            routerName: 'setWorkOrder',
            router: '/projectsubject/systemSettings/setWorkOrder',
            hide: "10",
            child: []
          },
          {
            name: "管理员设置",
            //		 icon:"iconfont icontiezixiugai",
            id: "company.system.admin",
            routerName: 'administratorSet',
            router: '/projectsubject/systemSettings/administratorSet',
            hide: "10",
            child: []
          },
          {
            name: "通知公告",
            //									icon:"iconfont iconrenyuanliebiao",
            id: "D080D",
            routerName: 'companyNoticeList',
            router: "/projectsubject/businessAdministration/companyNoticeList",
            hide: "10",
            child: []
          },
        ]
      },
      // {
      //   name: "意见反馈",
      //   icon: "iconfont iconziyuan",
      //   id: "H0000",
      //   routerName: 'feedback',
      //   router: "/projectsubject/feedback",
      //   hide: "11",
      //   child: []
      // },
      // {
      // 	name: "消息",
      // 	icon: "iconfont iconziyuan",
      // 	id: "I0000",
      // 	router: "/projectsubject/message",
      // 	hide: "00",
      // 	child: []
      // }
    ],
    hideArray: ['H0000', 'D0000', 'D050A', 'D050B', 'D060A', 'D060B', 'D080B', "D080C", "D080D", 'F0500', 'F0000',
      'F0100', 'F0200', 'F0300', 'F0400', "E0112", 'E0111', 'F0600', 'projectE0100', 'D0100', 'D0700', 'E01011E',
      'E01011F', 'D080E', 'D080E1', 'D080E2', 'E0200'
    ], //非企业权限   或非
    administrative: ['C0000', 'H0000'], //非企业权限   行政版
    notToJoin: ['A0000', 'H0000'], //新用户


    jurProject: ['project.base.operation'], //


    HomeRoute: ''
  },
  mutations: { //单一事件处理器

  },
  actions: { //多事件处理机

  },
  getters: { //监听器
    //	    doneProject: state => {
    //	      return state.jurProject
    //	    },
    size: state => {
      window.onresize = function() {
        this.$message.error(1);
      }
    },
    routerSite: state => {
      return state.HomeRoute
    }
  },
}



// WEBPACK FOOTER //
// ./src/store/StateMachine/pageRouteStore.js